import cn from "classnames";

import Preloader from "components/Preloader/Preloader";

import styles from "./preloader-wrapper.module.scss";

interface IPreloaderWrapper {
  loading?: boolean | string;
  isAbsolute?: boolean;
  children?: any;
  opacity?: boolean;
  title?: string;
}

const PreloaderWrapper = ({
  title,
  loading,
  isAbsolute,
  children,
  opacity
}: IPreloaderWrapper) => {
  return (
    <div
      className={cn(styles["preloader-container"], {
        [styles["preloader-container-loading"]]: loading,
        [styles["opacity"]]: opacity
      })}
    >
      {loading && (
        <Preloader isChildPreloader isAbsolute={isAbsolute} title={title} />
      )}
      {children}
    </div>
  );
};

export default PreloaderWrapper;
